import React from 'react';
import ReactDOM from 'react-dom';
import Autosuggest from 'react-autosuggest'
import './InstrumentAutosuggest.css'
import axios from 'axios'

class InstrumentAutosuggest extends React.Component {
  constructor(props) {
    super(props);
    // Autosuggest is a controlled component.
    // This means that you need to provide an input value
    // and an onChange handler that updates this value (see below).
    // Suggestions also need to be provided to the Autosuggest,
    // and they are initially empty because the Autosuggest is closed.
    this.state = {
      value: this.props.value ? this.props.value : '',
      suggestions: [],
    };
  }

  onChange = (event, { newValue }) => {
    this.UserInput = newValue;
    if (this.props.onChange) {
      this.props.onChange(newValue);
    }
    this.setState({
      value: newValue
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    // window.alert(window.location.href.toString() + "listInstruments");
    axios.get(window.location.href.toString() + "instruments" + "?" + "symbol=" + value)
    .then(res => {
      var buildSuggestions = []
      for (var index =0; index < res.data.length; index++) {
        buildSuggestions.push( {
          name:res.data[index].name,
          symbol:res.data[index].symbol,
          currency:res.data[index].currency,
          exchange:res.data[index].exchange
        });
      }
         this.setState({
           suggestions:buildSuggestions
         })
    })
    .catch(function (error) {
      window.alert("unable to get instrumentsdata " + error.toString());
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: 'Type Instrument',
      value: this.props.value ? this.props.value : "",
      onChange: this.onChange
    };

    // Finally, render it!
    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion.symbol + "." + suggestion.exchange + " " + suggestion.name + "("+suggestion.currency + ")";

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {suggestion.symbol + "." + suggestion.exchange + " " + suggestion.name + "("+suggestion.currency + ")"}
    </div>
);

export default InstrumentAutosuggest
